import { routes as queueRoutes } from "./queue/routes";
import { routes as recordTestsRoutes } from "./record-tests/routes";
import { routes as previousRoutes } from "./previous/routes";
import { routes as labReportRoutes } from "./report/routes";

export const routes = [
    ...queueRoutes(),
    ...recordTestsRoutes(),
    ...previousRoutes(),
    ...labReportRoutes(),
];
